var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:[
    'pdf-export-block',
    'pdf-export-header'
  ]},[_c('h1',[_vm._v(_vm._s(_vm.employerName))]),_c('h2',[_vm._v(_vm._s(_vm.title)+" as of "+_vm._s(_vm.today))]),(_vm.showFilters)?_c('div',{staticClass:"applied-filters"},[_vm._l((_vm.renderedFilters),function(filter){return [(filter.values.length)?_c('p',{key:filter.type},[_c('strong',[_vm._v(_vm._s(filter.type))]),_vm._v(": "+_vm._s(filter.values.join('; '))+"\n      ")]):_vm._e()]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }